/** Chrome/Firefox cannot decode HEIC/HEIF in <img> — detect URLs that will fail in-browser. */

/** Shared photo card / grid display for travel-kit edit and public file-detail — keep in sync. */

export function isHeicOrHeifUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  const path = value
    .toLowerCase()
    .trim()
    .split("?")[0]
    .split("#")[0];
  return /\.(heic|heif)$/.test(path);
}

export function isHeicImageMedia(media: { fileName?: string; url?: string } | null | undefined): boolean {
  if (!media) return false;
  return isHeicOrHeifUrl(media.fileName || "") || isHeicOrHeifUrl(media.url || "");
}

/** Prefer non-HEIC thumbnail, then non-HEIC url. */
export function getBrowserPhotoDisplayUrl(media: { thumbnail?: string; url?: string } | null | undefined): string {
  if (!media) return "";
  const thumb = typeof media.thumbnail === "string" ? media.thumbnail.trim() : "";
  const url = typeof media.url === "string" ? media.url.trim() : "";
  if (thumb && !isHeicOrHeifUrl(thumb)) return thumb;
  if (url && !isHeicOrHeifUrl(url)) return url;
  return thumb || url;
}

export function shouldRenderPhotoInBrowser(
  media: { thumbnail?: string; url?: string; imageLoadError?: boolean } | null | undefined
): boolean {
  if (!media || media.imageLoadError) return false;
  const displayUrl = getBrowserPhotoDisplayUrl(media);
  if (!displayUrl) return false;
  // Match file-detail / download UI: attempt <img> for HEIC too (Safari decodes HEIC; Chrome falls back via error handler).
  return true;
}

export function heicPreviewUnavailableLabel(media: { fileName?: string; url?: string } | null | undefined): string {
  if (isHeicImageMedia(media)) {
    return "HEIC — browser preview not supported";
  }
  return "Preview unavailable";
}
